/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { styled, Box, Typography, TextField, InputAdornment, Checkbox, Radio } from "@mui/material";
import { StyledFilterImage } from "../../styles";
import searchIcon from '../../../../assets/images/search.svg'
import { colors } from "../../../../themes/dashboard";
import { LoadingSpinner } from "../../../../components/loading_spinner";

export const StyledListItem = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: '6px 0px',
  borderBottom: "1px solid transparent",
})

export const StyledOption = styled(Typography)({
  fontWeight: '500',
  fontSize: '14px',
  letterSpacing: '0px',
})

const SearchIcon = () => {
  return (
    <StyledFilterImage src={searchIcon} alt="Location" />
  )
}

const StyledTextField = styled(TextField)({
  '& .MuiInputBase-input': {
    paddingTop: '12px',
    fontSize: '14px',
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: '8px',
    borderColor: '#E4E4E7'
  },
})

export const MobileFilterSearchBar = ({ changeSearchText, placeholder, isFetching = false }) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        pb: "15px",
        position: "sticky",
        pt: "15px",
        top: 0,
        zIndex: 1,
      }}
    >
      <StyledTextField
        size="small"
        autoFocus={false}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{ justifyContent: "center", minWidth: "20px" }}
            >
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  height: "20px",
                  justifyContent: "center",
                  width: "20px",
                }}
              >
                <LoadingSpinner isLoading={isFetching} />
              </Box>
            </InputAdornment>
          ),
        }}
        placeholder={placeholder}
        onChange={(e) => changeSearchText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== "Escape") {
            e.stopPropagation();
          }
        }}
      />
    </Box>
  )
}

export const StyledCheckBox = styled(Checkbox)({
  '&.Mui-checked': {
    color: colors.deep,
  },
  color: colors.unCheckedRadioButton,
})

export const StyledRadioButton = styled(Radio)({
  color: colors.unCheckedRadioButton,
  "&.Mui-checked": {
    color: colors.deep,
  },
})
